import { render, staticRenderFns } from "./livescanversion.vue?vue&type=template&id=b1a8c96c&scoped=true&"
import script from "./livescanversion.vue?vue&type=script&lang=js&"
export * from "./livescanversion.vue?vue&type=script&lang=js&"
import style0 from "./livescanversion.vue?vue&type=style&index=0&id=b1a8c96c&prod&lang=css&"
import style1 from "./livescanversion.vue?vue&type=style&index=1&id=b1a8c96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8c96c",
  null
  
)

export default component.exports